<template>
    <div class="n-flex n-flex-a-c n-flex-dr-c n-flex-j-c n-h-1 n-p-2 c-max-width n-m-auto">
        <a-spin :spinning="loadings">
            <div class="n-col-1 c-shadow info n-flex n-flex-dr-c n-bg-1 n-radius-20 n-p-6"
                 style="width: 500px; max-width: 100%;">
                <h1 class="n-flex n-flex-a-c n-f-10">
                    <ProfileOutlined class="n-mr-2"
                                     style="font-size: 24px;" />{{ LAN.cart.orderSummary }}
                </h1>
                <div class="n-col-1">
                    <ul class="n-ul n-p-0 n-m-0 n-col-1">
                        <li class="n-flex n-flex-a-c n-flex-j-sb n-b-line n-ptb-3">
                            <span class="n-f-6 n-f-4">{{ LAN.cart.bookQty }}</span>
                            <span class="n-f-6 n-f-4">{{ cartDetailList.length }} items</span>
                        </li>
                        <li class="n-flex n-flex-a-c n-flex-j-sb n-ptb-3"
                            v-if="cartDetailList.length > 0">
                            <span class="n-f-6 n-f-4">{{ LAN.cart.totalAmount }}</span>
                            <span class="n-f-8 n-f-4 n-c-base n-f-bold">{{  cartDetailList[0]?.currency + totalPrice  }}</span>
                        </li>
                    </ul>

                    <div class="n-mt-3 checking-status n-plr-3 n-pt-3 n-pb-2"
                         :class="'checking-status-' + checking">
                        <h4 v-if="checking == 0"
                            class="n-f-6 n-f-bold n-c-base n-m-0 n-flex-g n-plr-2"><a-spin class="n-mr-4" /> {{ LAN.common.receivePaid }}</h4>

                        <h4 v-else-if="checking == 1"
                            class="n-f-6 n-f-bold n-c-green n-m-0 n-flex-g n-plr-2">
                            <CheckCircleFilled class="n-mr-1" />{{ LAN.common.successPaid }}
                        </h4>

                        <h4 v-else-if="checking == -1"
                            class="n-f-6 n-f-bold n-c-red n-m-0 n-flex-g n-plr-2">
                            <CloseCircleFilled class="n-mr-1" />{{ LAN.common.errorPaid }}
                        </h4>
                    </div>
                </div>

                <div class="n-mt-6 n-flex n-flex-a-c">
                    <a-button class="c-tab-link c-tab-link-event n-col-2 n-mr-3"
                              shape="round"
                              size="large"
                              @click="$router.replace({name: 'books'})">{{ LAN.common.backBook }}</a-button>
                    <a-button type="primary"
                              class="c-tab-link c-tab-link-event n-col-2"
                              shape="round"
                              size="large"
                              @click="$router.replace({name: 'mine', query: {type: 'order'}})">{{ LAN.common.goOrder }}</a-button>
                </div>
            </div>
        </a-spin>
    </div>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import { ProfileOutlined, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons-vue';
    import nui from '@/assets/script';
    import NImage from '@/components/nui/NImage/NImage.vue'
    import indexedDBManager from '@/assets/script/indexedDB';

    export default {
        name: 'NoAuth',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),

            totalPrice () {
                return parseFloat(this.cartDetailList.reduce((total, item) => {
                    return total + (item.listPrice * (item.quantity || 1));
                }, 0)).toFixed(2);
            }
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                publication: {},
                data: {},
                loadings: false,
                checking: 0,
                cartDetailList: []
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setMenuStatus'])),

            NMounted () {
                this.loadings = true

                this.request(this.API.cartList, {
                    method: 'post',
                    data: this.$route.query.pid.split(',').map(item => {
                        return {
                            objId: item,
                            objType: "BOOK"
                        }
                    })
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.cartDetailList = res.data
                    }
                    this.loadings = false;
                }).catch(err => {
                    this.loadings = false;
                });

                this.checking = 0;

                this.request(this.API.payStatus, {
                    params: { paymentIntentId: this.$route.query.payment_intent }
                }).then(async res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.checking = res.data ? 1 : -1

                        // 如果支付成功，删除购物车中对应的商品
                        if (res.data) {
                            await this.removeItemsFromCart();
                            this.$store.dispatch('cacheCartList');
                        }
                    }
                }).catch(err => {
                    this.checking = -1
                })
            },

            // 删除购物车中对应的商品
            async removeItemsFromCart () {
                try {
                    const pids = this.$route.query.pid.split(',');
                    await indexedDBManager.removeFromCartByPids(pids);

                    // 更新购物车列表缓存
                    this.$store.dispatch('cacheCartList');

                    console.log('已从购物车中删除支付成功的商品');
                } catch (error) {
                    console.error('删除购物车商品失败:', error);
                }
            }
        }),
        components: {
            NImage,
            ProfileOutlined,
            CheckCircleFilled,
            CloseCircleFilled
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .cart-item-image {
        width: 104px;
        height: 148px;
    }

    .checking-status {
        border: 1px solid rgb(255, 178, 178);
        border-radius: 10px;
        background-color: rgb(255, 237, 237);
    }

    .checking-status-1 {
        border: 1px solid rgb(219, 255, 229);
        border-radius: 10px;
        background-color: rgb(239, 255, 236);
    }
</style>